<div class="rate">
    @if (!finishedRating) {
    <div class="rate-title">{{ lang.data["block.rate.title"] }}</div>
    } @if (!showFeedback) {
    <div class="rate-actions">
        <div class="rate-negative rate-action pointer" (click)="rateArticle()">
            {{ lang.data["general.no"] }}
        </div>
        <div class="rate-positive rate-action pointer" (click)="rateArticle(1)">
            {{ lang.data["general.yes"] }}
        </div>
    </div>
    } @if (showFeedback && !finishedRating) {
    <div class="rate-feedback">
        <ion-textarea
            placeholder="{{ lang.data['block.rate.feedback_placeholder'] }}"
            [(ngModel)]="feedback"
        ></ion-textarea>
        <ion-button
            class="button-gray"
            shape="round"
            expand="full"
            (click)="sendFeedback()"
        >
            {{ lang.data["block.rate.send_feedback"] }}
        </ion-button>
    </div>
    } @if (finishedRating) {
    <div class="confirm-feedback">
        {{ lang.data["feedback.confirmation"] }}
    </div>
    }
</div>
